export default "__VITE_ASSET__Bta6W_yD__"